import React, { useState, useEffect } from "react";
import {
  formatDateHourToBR,
  updateData,
} from "../../../functions/functionsUtility";
import { getDataWithEndpoint } from "../../../functions/request";
import { DescriptionPeriodValue } from "../../../layout";

export default function DolarPtaxCotacao() {
  const [cotacoesData, setCotacoesData] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    getDataWithEndpoint("dolar_ptax", "getDolarPtax")
      .then((data) => {
        setCotacoesData(data);
      })
      .finally(() => {
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        setHasError(err?.message ?? "Ocorreu um erro.");
        console.log(err);
      });
  }, []);

  return (
    <>
      <DescriptionPeriodValue
        title={"Cotações Dolar Ptax"}
        onClickButton={() =>
          updateData({
            ...cotacoesData,
            path: "dolar_ptax",
            endpoint: "updateDolarPtax",
          })
        }
        date={formatDateHourToBR(cotacoesData.dol_data)}
        inputValue={cotacoesData["dol_valor"]}
        state={cotacoesData}
        setState={setCotacoesData}
        stateKey={"dol_valor"}
        isLoading={isLoading}
        hasError={hasError}
      />
    </>
  );
}
